'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosFlame = function IoIosFlame(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c6.8 5 13.3 14 12.4 22.5-1 10.5-8.1 12.5-9.9 12.5s-9.9-3.1-10-12.5c-0.1-11.4 9.5-11.2 7.5-22.5z m2.5 34.4s3.1-2.8 3.1-6.3-3.1-6.2-3.1-6.2-3.2 2.8-3.2 6.2 3.2 6.3 3.2 6.3z' })
        )
    );
};

exports.default = IoIosFlame;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-flame.js
// module id = 2159
// module chunks = 0